/*----------------------------------
- HOOK: PUBLISHED TLD PATHS
----------------------------------*/

import { useMemo } from 'preact/hooks';

import useContext from '@/client/context';

import { resolvePublishedTldPaths } from './presentation';

/**
 * The insight pages the warmup has published, or null when links are not gated (every profile
 * but prod). A static page renders once and is served for hours, so it links a `/tld/<slug>`
 * page only once that page is itself published: the same rule the header and the related links
 * apply to every `/domains` listing (see `server/config/app.ts`).
 */
export const usePublishedTldPaths = (): ReadonlySet<string> | null => {
    const { enforceDomainPublicationLinks, renderedDomainResourcePaths } = useContext();

    return useMemo(
        () => resolvePublishedTldPaths({ enforceDomainPublicationLinks, renderedDomainResourcePaths }),
        [enforceDomainPublicationLinks, renderedDomainResourcePaths],
    );
};
